<template>
    <Menu
        v-model:shown="model"
        popper-class="ew-menu"
        :triggers="triggers"
        :persistent="persistent"
        :auto-hide="autoHide"
        :placement="resolvedPlacement"
        :distance="resolvedDistance"
        :skidding="resolvedSkidding"
        :delay="delay"
        @show="emit('show')"
    >
        <slot name="trigger" :open="model">
            <button class="default-trigger">Menu</button>
        </slot>
        <template #popper>
            <slot :open="model"></slot>
        </template>
    </Menu>
</template>
<script setup>
import { Menu } from 'floating-vue';
import { computed, inject, provide } from 'vue';

const emit = defineEmits(['show']);
const menuContextKey = 'eventwise-menu-context';
const isSubmenu = inject(menuContextKey, false);

const props = defineProps({
    triggers: {
        type: [Array],
        default: () => ['hover'],
    },
    persistent: {
        type: Boolean,
        default: false,
    },
    placement: {
        type: String,
        default: undefined,
    },
    distance: {
        type: Number,
        default: undefined,
    },
    skidding: {
        type: Number,
        default: undefined,
    },
    autoHide: {
        type: Boolean,
        default: true,
    },
    delay: {
        type: [Number, Object],
        default: undefined,
    },
});

provide(menuContextKey, true);

const resolvedPlacement = computed(() => props.placement ?? (isSubmenu ? 'right-start' : 'bottom-end'));
const resolvedDistance = computed(() => props.distance ?? (isSubmenu ? 0 : 2));
const resolvedSkidding = computed(() => props.skidding ?? 0);

const model = defineModel({
    type: Boolean,
    default: false,
});
</script>
<style lang="scss">
.ew-menu {
    .v-popper__arrow-container {
        display: none;
    }
    ul {
        @apply tw-m-0 tw-flex tw-flex-col tw-py-1;
        li {
            &.separator {
                @apply tw-h-[1px] tw-bg-gray-200;
            }

            a,
            button {
                @apply tw-flex tw-gap-1 tw-py-1.5 tw-px-3 tw-w-full tw-text-sm tw-text-gray-800;

                &:has(i) {
                    @apply tw-pl-4;
                }
                & > i {
                    @apply tw-relative tw-block tw-left-[-3px] tw-top-[1px] tw-scale-110;
                }
                &:hover {
                    @apply tw-bg-gray-100;
                }
            }
        }
    }
}
</style>
